<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>{{model.name}}</strong> <span class="float-right">{{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_category">HASH(MD5)</label>
                <div class="ql-snow" v-html="model.md5"></div>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_title">File Name</label>
                <div class="ql-snow" v-html="model.name"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="ph_title">SSDEEP</label>
                <div class="ql-snow" v-html="model.ssdeep"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="ph_title">Category</label>
                <div class="ql-snow" v-html="codes.code_category[model.category] || 'Webshell'"></div>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="ph_title">Ext</label>
                <div class="ql-snow" v-html="model.ext"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="ph_title">Source</label>
                <div class="ql-snow" v-html="model.source || 'F1Security'"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>

          <b-form-group>
            <div style="max-height: 500px; overflow: auto; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;">
              {{(model.is_binary) ? model.data : 'File Content Confirm'}}
            </div>
          </b-form-group>
          <hr>
          <b-button size="sm" variant="success" @click="download" style="margin:0 5px;"> Download </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true" style="margin:0 5px;"> Remove </b-button>
          <!-- <input id="ph_title" type="checkbox" v-model="pattern_del">
          <label for="ph_title"> 패턴삭제</label> -->
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Would You Like to Remove?
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import forge from 'node-forge'
import iconv from 'iconv-lite'
import { saveAs } from 'file-saver/FileSaver';

export default {
  data : () => {
    return {
      confirm: false,
      pattern_del: true,
      lock: true,
      model : {},
      codes
    }
  },
  methods: {
    download: function(){
      let blob = new Blob([this.model.data], {type: "text/plain;charset=utf-8"});
      saveAs(blob, this.model.name+'.F1');
    },
    remove: function() {
      // return Api.Manager_Call('','', { id : this.model.id, pattern_del : this.pattern_del})
      return Api.Manager_Call('wsfinder.webshell','delete', { id : this.model.id})
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
        })
        .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    list: function() { this.$router.push({ name: 'wsfinder_webshell'}); },

    get: function(id = this.$route.params.id) {
      console.log('webshell.detail.vue', 'load item', id);
      Api.Manager_Call('wsfinder.webshell','detail', {id:id}).then(data => this.model = Object.assign({}, this.model, data.body))
      .then( model => {
        let decode = forge.util.decode64(model.data);
        if(!model.is_binary) { try { this.model.data = forge.util.decodeUtf8(decode);} catch(e) { this.model.data = iconv.decode(decode, 'Windows949');}}
      })
      .catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));

    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created: function() { console.log('webshell.detail.vue', 'created'); },
  destroyed: function() { console.log('webshell.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('webshell.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}
</script>
